export const APP_NAME = "Kya";
export const APP_DOMAIN = "kyahq.com";
export const APP_URL = "https://www.app.kyahq.com";
export const MARKETING_SITE_URL = "https://www.kyahq.com";
export const HIRE_SITE_URL = "https://hirekya.com";
export const SOCIAL_LINKEDIN_URL = "https://www.linkedin.com/company/kya-agents";
export const SOCIAL_X_URL = "https://x.com/kyaagents";

/** Where un-invited visitors are sent to request access. TODO: replace with the real booking link. */
export const BOOK_DEMO_URL = "https://www.kyahq.com/demo";
export const EMAIL_TAGLINE = "Customer agents that grow your revenue.";
export const FOUNDERS_DUAL_SIGNOFF = "John & Drew, founders of Kya";
export const UNSUBSCRIBE_URL = `${HIRE_SITE_URL}/emails`;

/** Browser tab title segments joined with " - ". */
export function pageTitle(...segments: string[]): string {
  return segments.join(" - ");
}
